const data: Array<{ title: string, value: string }> = [
  {
    title: 'Республика Адыгея (Адыгея)',
    value: '1',
  },
  {
    title: 'Республика Башкортостан',
    value: '2',
  },
  {
    title: 'Республика Бурятия',
    value: '3',
  },
  {
    title: 'Республика Алтай',
    value: '4',
  },
  {
    title: 'Республика Дагестан',
    value: '5',
  },
  {
    title: 'Республика Ингушетия',
    value: '6',
  },
  {
    title: 'Кабардино-Балкарская Республика',
    value: '7',
  },
  {
    title: 'Республика Калмыкия',
    value: '8',
  },
  {
    title: 'Карачаево-Черкесская Республика',
    value: '9',
  },
  {
    title: 'Республика Карелия',
    value: '10',
  },
  {
    title: 'Республика Коми',
    value: '11',
  },
  {
    title: 'Республика Марий Эл',
    value: '12',
  },
  {
    title: 'Республика Мордовия',
    value: '13',
  },
  {
    title: 'Республика Саха (Якутия)',
    value: '14',
  },
  {
    title: 'Республика Северная Осетия - Алания',
    value: '15',
  },
  {
    title: 'Республика Татарстан (Татарстан)',
    value: '16',
  },
  {
    title: 'Республика Тыва',
    value: '17',
  },
  {
    title: 'Удмуртская Республика',
    value: '18',
  },
  {
    title: 'Республика Хакасия',
    value: '19',
  },
  {
    title: 'Чеченская Республика',
    value: '20',
  },
  {
    title: 'Чувашская Республика - Чувашия',
    value: '21',
  },
  {
    title: 'Алтайский край',
    value: '22',
  },
  {
    title: 'Краснодарский край',
    value: '23',
  },
  {
    title: 'Красноярский край',
    value: '24',
  },
  {
    title: 'Приморский край',
    value: '25',
  },
  {
    title: 'Ставропольский край',
    value: '26',
  },
  {
    title: 'Хабаровский край',
    value: '27',
  },
  {
    title: 'Амурская область',
    value: '28',
  },
  {
    title: 'Архангельская область',
    value: '29',
  },
  {
    title: 'Астраханская область',
    value: '30',
  },
  {
    title: 'Белгородская область',
    value: '31',
  },
  {
    title: 'Брянская область',
    value: '32',
  },
  {
    title: 'Владимирская область',
    value: '33',
  },
  {
    title: 'Волгоградская область',
    value: '34',
  },
  {
    title: 'Вологодская область',
    value: '35',
  },
  {
    title: 'Воронежская область',
    value: '36',
  },
  {
    title: 'Ивановская область',
    value: '37',
  },
  {
    title: 'Иркутская область',
    value: '38',
  },
  {
    title: 'Калининградская область',
    value: '39',
  },
  {
    title: 'Калужская область',
    value: '40',
  },
  {
    title: 'Камчатский край',
    value: '41',
  },
  {
    title: 'Кемеровская область - Кузбасс',
    value: '42',
  },
  {
    title: 'Кировская область',
    value: '43',
  },
  {
    title: 'Костромская область',
    value: '44',
  },
  {
    title: 'Курганская область',
    value: '45',
  },
  {
    title: 'Курская область',
    value: '46',
  },
  {
    title: 'Ленинградская область',
    value: '47',
  },
  {
    title: 'Липецкая область',
    value: '48',
  },
  {
    title: 'Магаданская область',
    value: '49',
  },
  {
    title: 'Московская область',
    value: '50',
  },
  {
    title: 'Мурманская область',
    value: '51',
  },
  {
    title: 'Нижегородская область',
    value: '52',
  },
  {
    title: 'Новгородская область',
    value: '53',
  },
  {
    title: 'Новосибирская область',
    value: '54',
  },
  {
    title: 'Омская область',
    value: '55',
  },
  {
    title: 'Оренбургская область',
    value: '56',
  },
  {
    title: 'Орловская область',
    value: '57',
  },
  {
    title: 'Пензенская область',
    value: '58',
  },
  {
    title: 'Пермский край',
    value: '59',
  },
  {
    title: 'Псковская область',
    value: '60',
  },
  {
    title: 'Ростовская область',
    value: '61',
  },
  {
    title: 'Рязанская область',
    value: '62',
  },
  {
    title: 'Самарская область',
    value: '63',
  },
  {
    title: 'Саратовская область',
    value: '64',
  },
  {
    title: 'Сахалинская область',
    value: '65',
  },
  {
    title: 'Свердловская область',
    value: '66',
  },
  {
    title: 'Смоленская область',
    value: '67',
  },
  {
    title: 'Тамбовская область',
    value: '68',
  },
  {
    title: 'Тверская область',
    value: '69',
  },
  {
    title: 'Томская область',
    value: '70',
  },
  {
    title: 'Тульская область',
    value: '71',
  },
  {
    title: 'Тюменская область',
    value: '72',
  },
  {
    title: 'Ульяновская область',
    value: '73',
  },
  {
    title: 'Челябинская область',
    value: '74',
  },
  {
    title: 'Забайкальский край',
    value: '75',
  },
  {
    title: 'Ярославская область',
    value: '76',
  },
  {
    title: 'город федерального значения Москва',
    value: '77',
  },
  {
    title: 'город федерального значения Санкт-Петербург',
    value: '78',
  },
  {
    title: 'Еврейская автономная область',
    value: '79',
  },
  {
    title: 'Ненецкий автономный округ',
    value: '83',
  },
  {
    title: 'Ханты-Мансийский автономный округ - Югра',
    value: '86',
  },
  {
    title: 'Чукотский автономный округ',
    value: '87',
  },
  {
    title: 'Ямало-Ненецкий автономный округ',
    value: '89',
  },
  {
    title: 'Запорожская область',
    value: '90',
  },
  {
    title: 'Республика Крым',
    value: '91',
  },
  {
    title: 'город федерального значения Севастополь',
    value: '92',
  },
  {
    title: 'Донецкая Народная Республика',
    value: '93',
  },
  {
    title: 'Луганская Народная Республика',
    value: '94',
  },
  {
    title: 'Херсонская область',
    value: '95',
  },
  {
    title: 'Иные территории, включая город и космодром Байконур',
    value: '99',
  },
];

export default data;
